<template>
    <div
        :class="{
            'confirmation-container': !mode,
            'confirmation-container-events': mode === 'confirm'
        }"
    >
        <div class="confirmation-modal">
            <div class="confirmation-contents">
                <div class="icon">
                    <img src="/images/icons/envelope.png" alt="envelope-icon" />
                </div>
                <div class="title">
                    <p>CONFIRM YOUR EMAIL ADDRESS</p>
                </div>
                <div class="message">
                    <p>
                        In order to use and activate your account, you need to confirm your
                        email address.
                    </p>
                    <p>
                        Check your email and find the confirmation email (subject: "Hedlyner
                        Email Activation").
                    </p>
                    <p>Follow the steps in the email to activeate your email address.</p>
                </div>
                <div class="troubleshoot">
                    <p class="title">Didn't receive an email from us?</p>
                    <div class="solution-one">
                        <ol>
                            <li>Check your spam folder.</li>
                            <li>
                                If you still can't find the email, add shows@hedlyner.com to
                                your address book.
                            </li>
                            <li>Request a new activation email.</li>
                        </ol>
                    </div>
                    <div class="solution-two">
                        <p>If your activation link doesn't work:</p>
                        <ol>
                            <li>Copy the entire URL.</li>
                            <li>
                                Paste the URL into your browser's address bar and press Enter.
                            </li>
                            <li>If the link expired, request a new link.</li>
                        </ol>
                    </div>
                </div>
                <button v-if="!mode" @click="handleConfirm" class="confirm-btn">GOT IT</button>
                <button v-if="mode === 'confirm'" @click="closeModal" class="confirm-btn">
                    GOT IT
                </button>
                <button @click="goTo2FaResend" class="resend-btn">
                    CLICK HERE TO SEND A NEW ACTIVATION EMAIL
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Confirmation',
        props: {
            mode: {
                type: String
            },
            isVisible: {
                type: String
            }
        },

        methods: {
            handleConfirm() {
                this.$emit('ok')
            },

            goTo2FaResend() {
                window.location.href = '/email/resend'
            },

            closeModal() {
                this.$emit('update:isVisible', '')
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .confirmation-container {
        min-width: 100vw;
        min-height: 2000px;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.4);

        position: absolute;
        display: flex;
        justify-content: center;
        z-index: 1;

        .confirmation-modal {
            margin-top: 323px;
            min-width: 1170px;
            max-height: 1022px;
            overflow: hidden;
            border-radius: 20px;

            p {
                text-align: center;
                color: white;
            }

            .confirmation-contents {
                background-color: #1b0d29;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;

                .icon {
                    margin-top: 126px;
                    border-radius: 50%;
                    background: #49306b;
                    padding: 24px 19px 24px 19px;

                    img {
                        width: 34px;
                        height: 24px;
                    }
                }

                .title {
                    margin-top: 44px;
                    font-family: 'Instrument Sans';
                    font-style: normal;
                    font-weight: 800;
                    font-size: 30px;
                    line-height: 37px;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    color: white;

                    p {
                        margin-bottom: 0px;
                    }
                }

                .message {
                    margin-top: 26px;
                    p {
                        font-family: Instrument Sans;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 27px;
                        text-align: center;
                        color: white;
                        margin-bottom: 0px;
                    }
                }

                .troubleshoot {
                    margin-top: 44px;
                    margin-right: 65px;

                    .title {
                        margin-top: 0px;
                        font-family: 'Instrument Sans';
                        font-style: normal;
                        font-weight: 800;
                        font-size: 24px;
                        line-height: 29px;
                        color: white;
                        text-align: left;
                        margin-left: 12px;
                        text-transform: none;
                    }

                    li {
                        font-family: Instrument Sans;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 27px;
                        color: white;
                    }

                    .solution-one {
                        margin-top: 14px;
                    }

                    .solution-two {
                        margin-top: 50px;

                        p {
                            text-align: left;
                            margin-left: 12px;
                            font-family: Instrument Sans;
                            font-style: normal;
                            font-weight: 400;
                            font-size: 18px;
                            line-height: 27px;
                            color: white;
                            margin-top: 0px;
                            margin-bottom: 0px;
                        }
                    }
                }

                .confirm-btn {
                    margin-top: 44px;
                    min-width: 197.5px;
                    min-height: 61px;
                    background: #d7eb5a;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.17);
                    border-radius: 50px;
                }

                .resend-btn {
                    margin-top: 45px;
                    margin-bottom: 128px;
                    background: url(/images/icons/resend.png);
                    background-repeat: no-repeat;
                    background-position: 0px -2px;
                    background-size: 25px 25px;
                    font-family: 'Instrument Sans';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 22px;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    color: #d7eb5a;
                    border: none;
                    min-width: 558px;
                    padding-left: 25px;
                }
            }
        }
    }
</style>
